import { render, staticRenderFns } from "./TelcoEditarForm.vue?vue&type=template&id=2a286574&"
import script from "./TelcoEditarForm.vue?vue&type=script&lang=ts&"
export * from "./TelcoEditarForm.vue?vue&type=script&lang=ts&"
import style0 from "./TelcoEditarForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports